import { css } from "@emotion/react";
import { buttonBaseClasses, inputAdornmentClasses } from "@mui/material";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const root = ({ colorsV2, fontSizesV2 }: ExactTheme) =>
  css({
    position: "relative",
    color: colorsV2.grey[900],
    fontSize: fontSizesV2.body,
  });

export const datePicker = css({
  [`& .${inputAdornmentClasses.root}`]: {
    margin: 0,
    padding: 0,
    fontSize: 15,
    width: 34,
    height: "100%",
    maxHeight: "unset",
  },
  [`& .${buttonBaseClasses.root}`]: {
    margin: 0,
    fontSize: "unset",
  },
});
